import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../../constants/globalConstants'
import { Circles } from 'react-loader-spinner'
import { getPassList } from '../../../redux/actions/passListAction'
import moment from 'moment'
import { renderNoResults } from '../../../components/global/NoDataFound'
import { phoneMasker } from '../../../utils/helper'
import { downloadPassTicket } from '../../../redux/actions/widgetReservationAction'
import PassWalletButtons from '../../../components/global/PassWalletButtons'
import { APICONFIG } from '../../../redux/config/apiConfig'
// import { Link } from 'react-router-dom'

// let moment = require('moment')

function PassList(props) {
    const { dispatch, loader, notify, partnerDetails } = props
    const [passListData, setPassListData] = useState(EMPTY_ARRAY)
    const [displayCheckIn, setDisplayCheckIn] = useState(false)
    const [loaderTicket, setLoaderTicket] = useState(false)
    // const [userData, setUserData] = useState(EMPTY_OBJECT)


    useEffect(() => {
        // Error showing resolved
        setTimeout(() => {
            dispatch(getPassList()).then((res) => {
                if (res) {
                    // const userData = localStorage.getItem('userData')
                    // const userDetails = JSON.parse(userData)
                    // setUserData(userDetails)
                    setPassListData(res?.data)
                }
            })
        }, 500)

    }, [EMPTY_ARRAY])

    const handleshowCheckIn = () => {
        setDisplayCheckIn(!displayCheckIn)
    }
    const handleDownloadTicket = (Id, ticketNumber) => {
        if (!loaderTicket) {
            setLoaderTicket(true)
            dispatch(downloadPassTicket(Id, ticketNumber, setLoaderTicket))
        }
    }
    console.log('passListData', passListData)
    return (
        loader ? <span className='ms-2 d-flex justify-content-center'><Circles
            height="50"
            width="50"
            color="var(--bs-primary)"
            ariaLabel="circles-loading"
            visible={true}
        /></span> :
            <div>
                <div className="d-flex justify-content-between mb-2 p-2">
                    <h4 className="fw-bold">Passes</h4>
                    {/* <Link to='/'>
                    <button className="btn btn-success ms-auto"><i className="fa fa-plus"></i> Add</button>
                </Link> */}
                </div>
                {passListData?.length > 0 ? <ul className="permitList">
                    {passListData?.map((item, index) => {
                        if (item == null) return null
                        // const is_active = moment(item?.desired_end_date).format('MM/DD/YYYY') > moment().format('MM/DD/YYYY')
                        return (
                            <li className={item?.remaining_days > 0 ? 'active listItem card border-opacity-25' : 'inactive card listItem border-opacity-25'} key={index}>

                                <div className={item?.remaining_days > 0 ? 'card-header border-0 bg-success bg-opacity-10' : 'card-header border-0 bg-danger bg-opacity-10'} >
                                    <div className='d-flex justify-content-between'>
                                        <h5 className='mb-0 fw-bold'>{item?.rate?.description} {item?.facility?.full_name ? `- ${item?.facility?.full_name}` : ''}</h5>
                                        <small className={item?.remaining_days > 0 ? 'text-success' : 'text-danger'}><i className='fa fa-circle '></i> {item?.remaining_days > 0 ? 'Active' : 'In-active'}</small>
                                    </div>
                                </div>
                                <div className='card-body'>
                                    <div className='row mb-3'>
                                        <div className='col-sm-3 mb-sm-0'>
                                            <p className='text-muted mb-0'><b>Pass No: </b></p><span className='text-muted'>{item?.pass_code}</span>
                                        </div>
                                        <div className='col-sm-3 mb-sm-0'>
                                            <p className='text-muted mb-0'><b>Pass Start Date: </b></p><span className='text-muted'>{moment(item?.start_date).format('MM-DD-YYYY')}</span>
                                        </div>
                                        <div className='col-sm-3 mb-sm-0'>
                                            <p className='text-muted mb-0'><b>Pass End Date: </b></p><span className='text-muted'>{moment(item?.end_date).format('MM-DD-YYYY')}</span>
                                        </div>
                                        <div className='col-sm-3 mb-sm-0'>
                                            <p className='text-muted mb-0'><b>Total Usage: </b></p><span className='text-muted'>{item?.total_days}</span>
                                        </div>

                                    </div>
                                    <div className='row mb-3'>
                                        {/* <div className='col-sm-3 mb-sm-0'>
                                            <p className='text-muted mb-0'><b>Pass Start Time: </b></p><span className='text-muted'>{item?.start_time}</span>
                                        </div> */}
                                        {/* <div className='col-sm-3 mb-sm-0'>
                                            <p className='text-muted mb-0'><b>Pass End Time: </b></p><span className='text-muted'>{item?.end_time}</span>
                                        </div> */}

                                        <div className='col-sm-3 mb-sm-0'>
                                            <p className='text-muted mb-0'><b>Consumed Usage: </b></p><span className='text-muted'>{item?.consume_days}</span>
                                        </div>
                                        <div className='col-sm-3 mb-sm-0'>
                                            <p className='text-muted mb-0'><b>Remaining Usage: </b></p><span className='text-muted'>{item?.remaining_days}</span>
                                        </div>
                                        <div className='col-sm-3 mb-sm-0'>
                                            <p className='text-muted mb-0'><b>Pass Type: </b></p><span className='text-muted'>{item?.rate?.description}</span>
                                        </div>
                                        {item?.license_number ? <div className='col-sm-3 mb-sm-0'>
                                            <p className='text-muted mb-0'><b>Driving License Number: </b></p><span className='text-muted'>{item?.license_number}</span>
                                        </div> : null}
                                    </div>
                                    <hr />
                                    <div className='row mb-3'>
                                        <div className='col-sm-3 mb-sm-0'>
                                            <p className='text-muted mb-0'><b>First Name: </b></p><span className='text-muted'>{item?.user?.first_name}</span>
                                        </div>
                                        <div className='col-sm-3 mb-sm-0'>
                                            <p className='text-muted mb-0'><b>Last Name: </b></p><span className='text-muted'>{item?.user?.last_name}</span>
                                        </div>
                                        <div className='col-sm-3 mb-sm-0'>
                                            <p className='text-muted mb-0'><b>Email: </b></p><span className='text-muted'>{item?.user?.email}</span>
                                        </div>
                                        <div className='col-sm-3 mb-sm-0'>
                                            <p className='text-muted mb-0'><b>Phone: </b></p><span className='text-muted'>{phoneMasker(item?.user?.phone)}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='row justify-content-end align-items-center px-3'>
                                    {(item?.id && item?.pass_code && item?.remaining_days > 0) ? <div className="col-9 col-sm-4">
                                        <PassWalletButtons
                                            ticketId={item?.pass_code}
                                            googleWalletApi={APICONFIG.getGooglePassWalletDownload}
                                            appleWalletApi={APICONFIG.getApplePassWalletDownload}
                                            notify={notify}
                                            // isAction
                                            partnerDetails={partnerDetails}
                                        />
                                    </div> : null}
                                    {(item?.id && item?.pass_code && item?.remaining_days > 0) ? <div className="col-auto">

                                        <button className="btn btn-primary btn-sm" onClick={() => handleDownloadTicket(item.id, item.pass_code)} disabled={loaderTicket} >
                                            <i className="fa fa-download"></i>
                                        </button>
                                    </div> : ''}
                                </div>
                                {(item?.ticket && item?.ticket.length > 0) ? <span className=' fw-bold text-primary text-decoration-underline ms-3' onClick={() => handleshowCheckIn()} >{displayCheckIn ? 'Hide Check-In List' : 'Show Check-In List'}</span> : ''}
                                <div className="card-body table-responsive">
                                    {(displayCheckIn && item?.ticket.length > 0) ?
                                        <table className="table table-borderless">
                                            <thead>
                                                <tr className='text-muted'>
                                                    <th scope="col" className='tableLicensePlate'>Ticket number</th>
                                                    {/* <th scope="col">Pass No</th> */}
                                                    <th scope="col">Check-In Time</th>
                                                    <th scope="col">Check-Out Time</th>
                                                    {/* <th scope='col'>Amount</th> */}
                                                    <th scope='col'>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {item?.ticket?.map((ticket, key) => {
                                                    return <tr key={key}>
                                                        <td className='ps-2 p-0 m-0'>{ticket?.ticket_number}</td>
                                                        {/* <td>{ticket?.user_pass_id}</td> */}
                                                        <td className='ps-2 p-0 m-0'>{ticket?.checkin_time ? moment(ticket?.checkin_time).format('MM/DD/YYYY') + ', ' + moment(ticket?.checkin_time).format('h:mm A') : '-'}</td>
                                                        <td className='ps-2 p-0 m-0'>{ticket?.checkout_datetime ? moment(ticket?.checkout_datetime).format('MM/DD/YYYY') + ', ' + moment(ticket?.checkout_datetime).format('h:mm A') : '-'}</td>
                                                        {/* <td>{ticket?.length}</td> */}
                                                        <td className='ps-2 p-0 m-0'>{ticket?.is_closed == 1 ? 'InActive' : 'Active'}</td>
                                                    </tr>
                                                })}

                                            </tbody>
                                        </table> : ''}
                                </div>
                            </li>
                        )

                    })}
                </ul> : renderNoResults()}
            </div>
    )
}

PassList.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    notify: PropTypes.func,
    partnerDetails: PropTypes.object
}

PassList.defaulProps = {
    dispatch: noop,
    loader: PropTypes.bool,
    notify: noop,
    partnerDetails: EMPTY_OBJECT
}

function mapStateToProps({ passListReducer }) {
    return {
        loader: passListReducer?.loader,
    }
}
export default connect(mapStateToProps)(PassList)